import { Injectable, Optional, SkipSelf } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IPlantSelected } from "src/app/Utilities/Interfaces/IAppService";
import { IUserLogin } from "src/app/Utilities/Interfaces/IUserLogin";
import {
  NotificationService,
  NotificationType,
} from "src/app/generics/services/notification.service";
import {
  SweetAlert2Service,
  SweetAlertResult,
} from "src/app/generics/services/sweet-alert2.service";
import { InvoiceModalDetailComponent } from "../modal/invoice-modal-detail/invoice-modal-detail.component";
import * as moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { FormBuilder } from "@angular/forms";
import { EUserTypes } from "../enums/systemEnums";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { SweetAlertIcon } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AppService {
  /**
   * Set name key to translate title page
   */
  public TitlePage: string;
  public ShowProgressBar: boolean = false;
  public TranslateAp: TranslateService;
  public Moment = moment;
  public TokenLogin: string;
  public PlantSelected: IPlantSelected = {
    ShelterID: null,
    CorporateID: null,
    PlantID: null,
  };
  public Notify: NotificationService;
  public SweetAlert: SweetAlert2Service;
  public UserLogin: IUserLogin;
  public DialogMat: MatDialog;
  /**System Enums */
  public EUserTypes = EUserTypes;
  public Router: Router;

  public PayrollHeaders: string[] = [
    "Confidencialidad",
    "Departamento",
    "DeptoSubcuenta",
    "Area",
    "TipodePeriodo",
    "Ano",
    "Numero",
    "Horas",
    "Extras",
    "Adicionales",
    "Desc.Trabajado",
    "FestTrabajado",
    "TotalHrs",
    "NormalDev",
    "SeptimoDia",
    "ExtrasDobles",
    "ExtrasTriples",
    "Vacaciones",
    "PrimaVac",
    "PrimaDominical",
    "Aguinaldo",
    "HrsAjuste",
    "Vales",
    "Retroactivo",
    "Compensacion",
    "Indemn20dias",
    "Indemn90dias",
    "PrimaAntig",
    "GratifxSepara",
    "CompenTC",
    "BonoProduct",
    "FestLab",
    "DescTrab",
    "BonoRecomendacion",
    "BonifFonacot",
    "BonifInfonavit",
    "BonoPunt",
    "BonoCafeteria",
    "ApoyoExtraordinario",
    "SubsIncapacidad",
    "Reserv1",
    "Reserv2",
    "Reserv3",
    "Reserv4",
    "Reserv5",
    "Percepciones",
    "ISPT",
    "IMSS",
    "INFONAVIT",
    "Fondo Ahorro",
    "Gafete",
    "Uniforme",
    "GtosMedMayores",
    "Herramientas",
    "Candado",
    "Comedor",
    "Deducciones",
    "Total Neto",
    "Descuentos",
    "Cuotas Obrero Pat",
    "Cesantia",
    "ImptoEstado",
    "ImptoEduc",
    "SAR",
  ];

  constructor(
    private http: HttpClient,
    private _router: Router,
    //private authService: AuthService,
    public FormBuilder: FormBuilder,
    private _dialog: MatDialog,
    public _translateService: TranslateService,
    private _notificationService: NotificationService,
    private _sweetAlert: SweetAlert2Service,
    private _matDialog: MatDialog,
    @Optional() @SkipSelf() sharedService?: AppService
  ) {
    if (sharedService)
      throw new Error(
        "AppService - Is already loaded, remove from array providers in others components you try load, see the error for more"
      );
    console.info("[APP]", "AppService Started succesfully");

    this.Router = _router;
    this.DialogMat = _dialog;
    this.Notify = _notificationService;
    this.SweetAlert = _sweetAlert;
    this.init();
  }

  /**
   * Initialize all variables needed to start use the app
   */
  async init() {
    await this.getUserLogin();
    await this.getJWT();
    await this.getPlantSelected();
  }

  setTitlePage(title: string) {
    this.TitlePage = title;
  }

  async getJWT() {
    this.TokenLogin = localStorage.getItem("jwt");
  }

  getPermissions(name: string) {
    let permissionString = localStorage.getItem("currentPermissions");
    let data = JSON.parse(permissionString);
    return data[name];
  }

  /**
   * Save on sessionStorate the plant selcted to use on plant filter
   * @param id PlantId
   */
  savePlant = (shelter: number, corporate: number, plant: number) => {
    if (shelter != null) localStorage.setItem("shelter", shelter.toString());
    if (corporate != null)
      localStorage.setItem("corporate", corporate.toString());
    if (plant != null) localStorage.setItem("plant", plant.toString());
    this.getPlantSelected();
  };

  private getPlantSelected() {
    this.PlantSelected.ShelterID =
      localStorage.getItem("shelter") != null
        ? parseInt(localStorage.getItem("shelter"))
        : null;
    this.PlantSelected.CorporateID =
      localStorage.getItem("corporate") != null
        ? parseInt(localStorage.getItem("corporate"))
        : null;
    this.PlantSelected.PlantID =
      localStorage.getItem("plant") != null
        ? parseInt(localStorage.getItem("plant"))
        : null;
  }

  async getUserLogin() {
    this.UserLogin = JSON.parse(localStorage.getItem("currentUser"));
  }

  //#region SWEETALERT

  /**
   * Show a sweetalert confirm
   * @param title Name key to translate title text
   * @param contentHTML
   * @returns bolean value to validate the alert if confirm or cancel
   */
  async showSweetAlertConfirm(
    title: string,
    message,
    icon: SweetAlertIcon = "warning"
  ) {
    let response: SweetAlertResult = await this._sweetAlert.showSwal(
      title,
      message,
      icon,
      true,
      { confirmButton: "btn btn-success", cancelButton: "btn btn-danger" },
      "Ok",
      "Cancel"
    );
    return response.isConfirmed;
  }

  async showSweetAlertConfirmInput(
    title: string,
    message,
    icon: SweetAlertIcon
  ) {
    return await this._sweetAlert.showSwalInput(
      title,
      message,
      icon,
      true,
      { confirmButton: "btn btn-success", cancelButton: "btn btn-danger" },
      "Ok",
      "Cancel"
    );
  }
  //#endregion

  /**
   * Show alert notification
   * @param TitleKey Name key to translate title
   * @param MessageKey Name key to traslate body message
   * @param type NotificationType alert [Danger,Success, info, ...]
   */
  showAlert(Title: string, Message: string, type: NotificationType) {
    this.Notify.create(Title, Message, type);
  }

  /**
   * Show notification
   * @param type Type of notification [success,danger,warning]
   * @param MsgOrKey Message to notification or name of key to translate if toTranslate is  equal than true
   * @param toTranslate If TRUE translate MsgOrKey
   */
  showNotification(type: string, message: string) {
    if (type == "danger") {
      this.Notify.showErrorNotification(message);
    } else if (type == "success") {
      this.Notify.showSuccessNotification(message);
    } else if (type == "warning") {
      this.Notify.showWarningNotification(message);
    } else {
      console.error("Tipo de notification no valida");
    }
  }
  //TRANSLATE

  /**
   * Get text translate
   * @param key name of key to translate on json fles
   * @returns text translated
   */
  translate = (key: string) => this._translateService.instant(key);

  //#region Modal Globales
  invoiceModalDetail = (id: number) =>
    this.DialogMat.open(InvoiceModalDetailComponent, {
      width: "700px",
      data: {},
    });

  //#endregion

  JsonToFormData(json: any): FormData {
    let formData: FormData = new FormData();

    Object.entries(json).forEach(([key, value]) => {
      if (value != null) {
        formData.append(key, value.toString());
      }
    });
    return formData;
  }

  ArrayObjectsToFormData(json: any): FormData {
    let formData: FormData = new FormData();

    Object.entries(json).forEach(([keyHeader, value], index) => {
      if (value != null) {
        if (typeof value == "object")
          Object.keys(value).forEach((key) =>
            formData.append(`${keyHeader}[${index}][${key}]`, value[key])
          );
        else formData.append(keyHeader, value.toString());
      }
    });
    return formData;
  }

  /**
   * Validate if required first disable row for you can delete
   * @param IsEnabled
   * @param isDelete
   * @returns
   */
  DeleteRequireDisabled(IsEnabled: boolean, isDelete: boolean) {
    return IsEnabled && !isDelete;
  }

  /**
   * Validate if the opinion cumplimiento is valid .
   * @param suppid ID of supplier
   * @returns TRUE or FALSE is valid.
   */
  async SupplierValidOpinionCumplimiento(suppid: number) {
    let response: any = await this.http
      .get(environment.apiUri + "/supplier/" + suppid)
      .toPromise();
    let date = this.Moment(response.pdfOPDate);
    let status = response.pdfOPStatus;

    if (moment().format("YYYY-MM") != date.format("YYYY-MM")) status = "UPLOAD";

    return status;
  }

  catchHandler(error) {
    this.Notify.create(
      "Error",
      error.error ? error.error.text : error.message,
      NotificationType.danger
    );
  }
}
